"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/support/getRequestId.ts
var getRequestId_exports = {};
__export(getRequestId_exports, {
  OBSERVABILITY_BLACKLIST: () => OBSERVABILITY_BLACKLIST,
  getRequestId: () => getRequestId
});
module.exports = __toCommonJS(getRequestId_exports);
var OBSERVABILITY_BLACKLIST = ["/health", "/live", "/ready"];
var uuidRegExp = /^([a-z0-9]+-){4}[a-z0-9]+$/;
var requestCount = 0;
var idByRequest = /* @__PURE__ */ new WeakMap();
function getRequestId(req) {
  if (idByRequest.has(req)) {
    return idByRequest.get(req);
  }
  const header = req.headers["x-request-id"];
  let id = Array.isArray(header) ? header[0] : header;
  if (!id || id.length > 36 || !uuidRegExp.test(id)) {
    if (false) {
      const path = getURLPath((_a = req.url) != null ? _a : "/");
      if (!exclude.includes(path)) {
        console.warn(
          "x-request-id contains an invalid ID",
          id,
          req.method,
          req.url
        );
      }
      id = v4();
    } else {
      id = `req-${++requestCount}`;
    }
  }
  idByRequest.set(req, id);
  return id;
}
